import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=063d471d&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=ts"
export * from "./forgotPassword.vue?vue&type=script&lang=ts"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=063d471d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d471d",
  null
  
)

export default component.exports